import PropTypes from 'prop-types'
import React, { useContext } from 'react'
import Context from '../../context'

function PurchaseInfo({ checkIsRed, checkValue }) {
  const { formObject, setFormObject } = useContext(Context)
  return (
    <div className="row">
      <div
        className="form-check form-group align-items-center col-6"
        style={{ paddingLeft: '40px' }}
      >
        <input
          checked={formObject.hasPurchaseInClub}
          onChange={() =>
            setFormObject({
              ...formObject,
              hasPurchaseInClub: !formObject.hasPurchaseInClub
            })
          }
          className="form-check-input"
          type="checkbox"
          id="hasPurchaseInClub"
        />
        <label htmlFor="hasPurchaseInClub" className="form-check-label">
          Possui venda no Clube
        </label>
      </div>
      {formObject.hasPurchaseInClub && (
        <div className="form-group col-12">
          <input
            value={formObject.purchaseInClubURL || ''}
            onChange={e =>
              setFormObject({
                ...formObject,
                purchaseInClubURL: e.target.value
              })
            }
            type="text"
            className={`form-control ${checkIsRed('purchaseInClubURL') && 'clube-border-danger'}`}
            placeholder="URL para Venda no Clube"
            onBlur={e => checkValue('purchaseInClubURL', e.target.value)}
          />
        </div>
      )}
    </div>
  )
}

PurchaseInfo.defaultProps = {
  checkValue: () => {},
  checkIsRed: () => {}
}

PurchaseInfo.propTypes = {
  checkValue: PropTypes.func,
  checkIsRed: PropTypes.func
}

export default PurchaseInfo
